import React, { useState } from 'react';
import { Div, Heading, P } from '@kizi/core-components';
import ReactPlayer from 'react-player';

interface InfoBlockProps {
  title?: string;
  text?: string;
  bg: string;
  color?: string;
  videoUrl?: string;
  imageUrl?: string;
  thumbnailText?: string;
}

// Dont give max-min width here, because it might be used from other comparators with other dimensions
// This component should be FLUID and dimensions/ordering should come from its container.
export const InfoBlock: React.FC<InfoBlockProps> = ({
  title,
  text,
  bg,
  color,
  videoUrl,
  imageUrl,
  thumbnailText,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const showThumbnailText = !isPlaying && thumbnailText;

  return (
    <Div
      bg={bg}
      color={color}
      borderRadius={2}
      p={videoUrl ? 0 : [4, null, 40]}
      style={{
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      {title && (
        <Heading variant="H3" as="h3" color="inherit">
          {title}
        </Heading>
      )}

      {text && (
        <P variant="bodyRegular" color="inherit">
          {text}
        </P>
      )}

      {videoUrl && (
        <Div height="100%">
          <ReactPlayer
            url={videoUrl}
            playing={isPlaying}
            light={imageUrl}
            previewTabIndex={30}
            width="100%"
            height="100%"
            onClickPreview={() => setIsPlaying(true)}
          />
          {showThumbnailText && (
            <Heading
              variant="H3"
              as="h3"
              color="inherit"
              mt={[-7]}
              textAlign="center"
            >
              {thumbnailText}
            </Heading>
          )}
        </Div>
      )}
    </Div>
  );
};
